export const DISPATCH_STATE_CHANGE = '@dispatchStatus/state-change';
export const DISPATCHES_COLLECTED = '@dispatchStatus/dispatches-collected';

export function updateDispatch(dispatchData) {
  return async (dispatch) => {
    dispatch({
      type: DISPATCH_STATE_CHANGE,
      payload: {
        dispatch: dispatchData
      }
    });
  };
}
